import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import axios from "../api/constant";
import {
  RejectRequirement,
  updateRequirement,
  modifydetails,
  getdistictName,
  getGPFromDistrictAndBlock,
  requirements,
  school_name_block_wise,
  weo_approval,
  getAllBlocksFromDistrict,
  head_office_secretary_approval,
  dwo_approval,
  dm_approval,
} from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Modal, Button, Typography } from "@mui/material";

const Requirements = ({ role, mainId, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [Block, setBlock] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [AllGPs, setAllGPs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [showRejectReason, setShowRejectReason] = useState(false);
  const [rejectReasonError, setRejectReasonError] = useState(false); // Change initial state to false
  const [DistrictName, setDistrictName] = useState([]);
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [markRequired, setMarkRequired] = useState(true);
  const [Allvillages, setAllVillages] = useState([]);
  const [District, setDistrict] = useState("");
  const [SchoolName, setSchoolName] = useState("");
  const [Allblocks, setAllBlocks] = useState([]);
  const [schoolId, setSchoolId] = useState("");
  const [postSchoolName, setPostSchoolname] = useState([]);
  const [districtDropdown, setDistrictDropdown] = useState("");

  const handleSchoolName = (e) => {
    try {
      // const selectedSchool = JSON.parse(e.target.value);
      setSchoolId(e.target.value);
      // setSchoolName(selectedSchool.code);
      // setPostSchoolname(selectedSchool.school_name);
      getAllrequirements(District, Block, e.target.value);
    } catch (error) {
      console.error("Error parsing JSON in handleSchoolName:", error);
    }
  };

  const handleBlockChange = (e) => {
    setBlock(e.target.value);
    setAllSchoolNames([]);
    setSchoolName("");

    const data = {
      block_code: e.target.value,
    };
    school_name_block_wise(data)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.result);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
    getAllrequirements(District, e.target.value, schoolId);
  };

  const getDistictNames = () => {
    getdistictName()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setDistrictName(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  useEffect(() => {
    getDistictNames();
  }, []);

  useEffect(() => {
    const data = {
      block_code: userData.data.block_code,
    };
    if (role == 5) {
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setAllSchoolNames(response.data.result);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }
  }, [districtDropdown]);

  const getAllrequirements = (district, block, school) => {
    setIsLoading(true);
    const data =
      role == 4
        ? {
            role: 4,
            school: userData.data.school_id,
            district: "",
            block: "",
          }
        : (role == 8 || role == 11 || role == 12 || role == 13? {
            role: 8,
            district: district
              ? district
              : District
              ? District
              : "all",
            block: block ? block : Block ? Block : "all",
            school: school
              ? school
              : schoolId
              ? schoolId
              : "all",
          } : (role == 5 ? {
            role: 5,
            block: userData.data.block_code,
            school: school
              ? school
              : schoolId
              ? schoolId
              : "all",
          } : role == 6 ? {
            role: 6,
            district: userData.data.district_code,
            block: block ? block : Block ? Block : "all",
            school: school
              ? school
              : schoolId
              ? schoolId
              : "all",
          } : role == 7 ? {
            role: 7,
            district: userData.data.district_code,
            block: block ? block : Block ? Block : "all",
            school: school
              ? school
              : schoolId
              ? schoolId
              : "all",
          }: {
            role: 3,
            district: district
              ? district
              : District
              ? District
              : "all",
            block: block ? block : Block ? Block : "all",
            school: school
              ? school
              : schoolId
              ? schoolId
              : "all",
          }));

    requirements(data).then((res) => {
      if (res.status === "success") {
        console.log(res);
        setRows(res.data);
        setFilteredData(res.data);
      } else {
        setRows([]);
        toast.error(t("No Data Available!"));
      }
    });
    setIsLoading(false);
  };

  useEffect(() => {
    getAllrequirements("");
  }, []);

  useEffect(() => {
    const filtered = rows.filter(
      (item) =>
        (item?.requirement_name &&
          item.requirement_name
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item?.school_id &&
          item.school_id.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    setFilteredData(filtered);
    setPage(0);
  }, [searchQuery, rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    // navigate(`/${role !== 5 ? "admin" : "dealer"}/admindetails/${id}`);
  };
  const handleUpdateClick = (row) => {
    setSelectedRow({
      ...row,
      old_quantity: row.quantity,
    });
    setModalOpen(true);
  };

  const handlerejectClick = (row) => {
    setSelectedRow(row);
    console.log("selectedRow", selectedRow);

    setModalOpen1(true);
  };

  const handleCloseModal = () => {
    setShowRejectReason(false);
    setModalOpen(false);
  };
  const handleCloseModal1 = () => {
    setShowRejectReason(false);
    setModalOpen1(false);
  };
  const handleAccept = (selectedRow) => {
    console.log(selectedRow);
    const postData =
      role == 5
        ? {
            requirement_id: selectedRow.requirement_id,
            UDISE_code: selectedRow.UDISE_code,
            school_id: selectedRow.school_id,
            gbc_id: selectedRow.gbc_id,
            hostel_id: selectedRow.hostel_id,
            weo: 1,
            dwo: 1,
            dm: 1,
            role_id: role,
            user_id: userData.data.id,
          }
        : role == 6 
        ? {
            requirement_id: selectedRow.requirement_id,
            UDISE_code: selectedRow.UDISE_code,
            school_id: selectedRow.school_id,
            gbc_id: selectedRow.gbc_id,
            hostel_id: selectedRow.hostel_id,
            dwo: 1,
          } 
        : role == 7 
        ? {
            requirement_id: selectedRow.requirement_id,
            UDISE_code: selectedRow.UDISE_code,
            school_id: selectedRow.school_id,
            gbc_id: selectedRow.gbc_id,
            hostel_id: selectedRow.hostel_id,
            dm: 1,
          } 
        : role == 8
        ? {
            requirement_id: selectedRow.requirement_id,
            UDISE_code: selectedRow.UDISE_code,
            school_id: selectedRow.school_id,
            gbc_id: selectedRow.gbc_id,
            hostel_id: selectedRow.hostel_id,
            head_office: 1,
            is_approve: 1,
            role_id: role,
            user_id: userData.data.id,
          }
        : {
            requirement_id: selectedRow.requirement_id,
            amenities_id: selectedRow.amenities_id,
            amenities_sub_type_id: selectedRow.amenities_sub_type_id,
            UDISE_code: selectedRow.UDISE_code,
            school_id: selectedRow.school_id,
            gbc_id: selectedRow.gbc_id,
            hostel_id: selectedRow.hostel_id,
            HM: 0,
            role_id: role,
            user_id: userData.data.id,
          };

    if (role == 5) {
      weo_approval(postData)
        .then((response) => {
          setModalOpen(false);
          getAllrequirements("");
          if (response.status == "success") {
            toast.success("Requirement Approved Successfully!");
          }
        })
        .catch((error) => {
          console.error("Error updating requirement:", error);
          toast.error(error.response.data.message);
        });
    } 
    else if (role == 6) {
      dwo_approval(postData)
        .then((response) => {
          setModalOpen(false);
          getAllrequirements("");
          if (response.status === "success") {
            toast.success(response.message || "DWO Approval Successful!");
          } else {
            toast.error(response.message || "DWO Approval Failed!");
          }
        })
        .catch((error) => {
          console.error("Error updating requirement:", error);
          toast.error(error.response.data.message);
        });
    } 
    else if (role == 7) {
      dm_approval(postData)
        .then((response) => {
          setModalOpen(false);
          getAllrequirements("");
          if (response.status === "success") {
            toast.success(response.message || "DM Approval Successful!");
          } else {
            toast.error(response.message || "DM Approval Failed!");
          }
        })
        .catch((error) => {
          console.error("Error updating requirement:", error);
          toast.error(error.response.data.message);
        });
    } 
    else if (role == 8) {
      head_office_secretary_approval(postData)
        .then((response) => {
          setModalOpen(false);
          getAllrequirements("");
          if (response.status == "success") {
            toast.success("Requirement Approved Successfully!");
          }
        })
        .catch((error) => {
          console.error("Error updating requirement:", error);
          toast.error(error.response.data.message);
        });
    } else {
      updateRequirement(postData)
        .then((response) => {
          setModalOpen(false);
          getAllrequirements("");
          if (response.status == "success") {
            toast.success("Requirement Approved Successfully!");
          }
        })
        .catch((error) => {
          console.error("Error updating requirement:", error);
          toast.error(error.response.data.message);
        });
    }
  };

  const handleModify = (selectedRow) => {
    if (selectedRow.quantity > selectedRow.old_quantity) {
      toast.error("Updated Quantity should be lesser than Proposed Quantity");
    } else {
      const postData = {
        quantity: selectedRow.quantity,
        old_quantity: selectedRow.old_quantity,
        school_id: selectedRow.school_id,
        user_id: "",
        role_id: "",
        requirement_id: selectedRow.requirement_id,
      };

      modifydetails(postData)
        .then((response) => {
          setModalOpen(false);
          toast.success("Successfully Modified");
          getAllrequirements("");
        })
        .catch((error) => {
          console.error("Error updating requirement:", error);
          toast.error(error.response.data.message);
        });
    }
  };

  const handleRejectWithReason = () => {
    setShowRejectReason(true);
    if (rejectReason.trim() === "") {
      setRejectReasonError(true);
      return;
    }

    const postData = {
      school_id: selectedRow.school_id,
      requirement_id: selectedRow.requirement_id,
      is_reject: true,
      remarks: rejectReason,
    };

    RejectRequirement(postData)
      .then((response) => {
        setModalOpen1(false);
        getAllrequirements("");
        toast.success(response.message || "Update successful");
      })
      .catch((error) => {
        console.error("Error rejecting requirement:", error);
        toast.error(
          error.response?.data?.message || "Failed to reject requirement"
        );
      });
  };

  const handleClearRejectReason = () => {
    setRejectReason("");
    setRejectReasonError(false);
  };

  const handleDistrictChange = (e) => {
    const selectedDistrictId = e.target.value;
    setDistrict(e.target.value);

    getAllBlocksFromDistrict(selectedDistrictId).then((res) => {
      if (res.status == "success") {
        setAllBlocks(res.data.new_asset_query);
      } else {
        setAllBlocks([]);
      }
    });
    getAllrequirements(selectedDistrictId, Block, schoolId);
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  useEffect(() => {
    if (role === 6 || role === 7) {
      const districtCode = userData.data.district_code;
      getAllBlocksFromDistrict(districtCode)
        .then((res) => {
          if (res.status === "success") {
            setAllBlocks(res.data.new_asset_query);
          } else {
            setAllBlocks([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching blocks:", error);
          setAllBlocks([]);
        });
    }
  }, [role, userData.data.district_code]);
  

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="my-4">{t("Approve Requirements")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                display: "flex",
                marginLeft: "3rem",
                width: "17rem",
                border: "",
                borderRadius: "35px",
                marginTop: "20px", // Additional style from your existing code
              }}
            />
          </div>
        </div>

        <div className="my-3 col-12 d-flex justify-content-between align-items-center">
          <div
            className="col-sm-3"
            style={{
              display: role == 4 ? "none" : role == 5 ? "none" : role == 6 ? "none" : role == 7 ? "none" : "block",
            }}
          >
            <label htmlFor="title" className="form-label">
              {t("District")}
            </label>
            <select
              name="asset_sub_type"
              onChange={handleDistrictChange}
              className="common-input form-select"
            >
              <option value="all">All</option>
              {DistrictName &&
                DistrictName.map((row, id) => (
                  <option
                    key={id}
                    value={row.district_code}
                    className="text-dark"
                  >
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <div
            className="col-md-3"
            style={{
              display: role == 4 ? "none" : role == 5 ? "none" : "block",
            }}
          >
            <label className="form-label">{t("Block")} </label>
            <select
              name="GP" // value={AssetsType}
              className="common-input form-select"
              onChange={handleBlockChange}
              required
            >
              <option value="all">All</option>
              {/* Map assetOptions to generate option elements */}
              {Allblocks &&
                Allblocks.map((row, index) => (
                  <option key={index} value={row.code}>
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <div
            className="col-md-3"
            style={{ display: role == 4 ? "none" : "block" }}
          >
            <label className="form-label">{t("School Name")} </label>
            <select
              name="SchoolName" // value={AssetsType}
              className="common-input form-select"
              onChange={handleSchoolName}
              required
            >
              <option value="all">All</option>
              {AllSchoolNames &&
                AllSchoolNames.map((row, index) => (
                  <option value={row.school_id}>{row.school_name}</option>
                ))}
            </select>
          </div>
          <button
            className="btn btn-primary btn-sm mx-5"
            style={{ marginTop: "35px", height: "30px" }}
            // onClick={getData}
          >
            {t("Search")}
          </button>
        </div>

        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Requirement")}</TableCell>
                  <TableCell align="center">{t("School Name")}</TableCell>
                  <TableCell align="center">{t("GBC")}</TableCell>
                  <TableCell align="center">{t("Hostel Type")}</TableCell>
                  <TableCell align="center">{t("District")}</TableCell>
                  <TableCell align="center">{t("Block")}</TableCell>
                  <TableCell align="center">{t("Quantity")}</TableCell>
                  <TableCell align="center">{t("Tentative Amount")}</TableCell>
                  <TableCell align="center">{t("Raised On")}</TableCell>
                  <TableCell align="center">
                    {t("Pending Date Count")}
                  </TableCell>
                  <TableCell align="center">{t("Action")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {getSerialNumber(index)}
                        </TableCell>
                        <TableCell align="center">
                          {row.requirement_name}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.school_name}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.gbc_type}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.hostel_type}
                        </TableCell>
                        <TableCell align="center">{row.district}</TableCell>
                        <TableCell align="center">{row.block}</TableCell>
                        <TableCell align="center">{row.quantity}</TableCell>
                        <TableCell align="center">
                          {row.tentative_amount}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.creation_date}
                        </TableCell>
                        <TableCell align="center">
                          {row.pending_date_count}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography
                            variant="button"
                            className="primary-btn btn btn-sm"
                            id="btn2"
                            style={{ margin: "8px" }}
                            onClick={() => handleAccept(row)}
                          >
                            {t("Accept")}
                          </Typography>
                          <Typography
                            variant="button"
                            className="primary-btn btn btn-sm"
                            style={{ margin: "8px" }}
                            hidden={role == 5 ? false : true}
                            id="btn1"
                            onClick={() => handleUpdateClick(row)}
                          >
                            {t("Modify")}
                          </Typography>
                          <Typography
                            variant="button"
                            style={{ margin: "8px" }}
                            className="primary-btn btn btn-sm"
                            id="btn3"
                            onClick={() => {
                              handleRejectWithReason();
                              handlerejectClick(row);
                            }}
                          >
                            {t("Reject")}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      {selectedRow && (
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          
          <div
            style={{
              position: "absolute",
              top: "32%",
              left: "52%",
              transform: "translate(-50%, -50%)",
              maxWidth: "90vw",
              width: "70%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <Typography variant="h6" gutterBottom>
              {t("Update Requirement")}
            </Typography>
            <div className="row mb-3 d-flex justify-content-around">
              <div className="col-md-3">
                <label className="form-label">{t("Requirement")}</label>
                <input
                  type="text"
                  name="requirement"
                  defaultValue={selectedRow.requirement_name}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">{t("Proposed  Quantity")}</label>
                <input
                  type="text"
                  name="old_quantity"
                  defaultValue={selectedRow.quantity}
                  className="form-control"
                  onChange={(e) => {
                    setSelectedRow((prevRow) => ({
                      ...prevRow,
                      old_quantity: e.target.value,
                    }));
                  }}
                  disabled
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">{t("Modify Quantity")}</label>
                <input
                  type="text"
                  name="quantity"
                  defaultValue={selectedRow.quantity}
                  className="form-control"
                  onChange={(e) => {
                    setSelectedRow((prevRow) => ({
                      ...prevRow,
                      quantity: e.target.value,
                    }));
                  }}
                  required
                />
              </div>
            </div>
            <div className="row mb-3"></div>
            {showRejectReason && (
              <div className="mb-3">
                <label className="form-label">
                  {t("Reason for Rejection")}
                </label>
                <input
                  type="text"
                  name="rejectreason"
                  value={rejectReason}
                  className={`form-control ${
                    rejectReasonError ? "border-danger" : ""
                  }`}
                  onChange={(e) => setRejectReason(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.target.value.length >= 5) {
                      setRejectReasonError(false);
                    }
                  }}
                  required
                />
                {rejectReasonError && (
                  <small className="text-danger">
                    {t("Reason for Rejection is required")}.
                  </small>
                )}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={() => handleModify(selectedRow)}
              >
                {t("Update")}
              </Button>
              <button
                variant="contained"
                color="primary"
                style={{ position: "absolute",
                top: 10,
                right: 10,
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer",}}
                onClick={handleCloseModal}
              >
                <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                    </svg>
              </button>
              
            </div>
          </div>
        </Modal>
      )}
      {selectedRow && (
        <Modal
          open={modalOpen1}
          onClose={handleCloseModal1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "30%",
              left: "52%",
              transform: "translate(-50%, -50%)",
              maxWidth: "90vw",
              width: "70%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <Typography variant="h6" gutterBottom>
              {t("Reject Requirement")}
            </Typography>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">{t("Requirement")}</label>
                <input
                  type="text"
                  name="requirement"
                  defaultValue={selectedRow.requirement_name}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("Quantity")}</label>
                <input
                  type="text"
                  name="quantity"
                  defaultValue={selectedRow.quantity}
                  className="form-control"
                  onChange={(e) => {
                    setSelectedRow((prevRow) => ({
                      ...prevRow,
                      quantity: e.target.value,
                    }));
                  }}
                  required
                />
              </div>
              {/* <div className="col-md-6">
                <label className="form-label">{t("Hostel Name")}</label>
                <input
                  type="text"
                  name="hostel-name"
                  defaultValue={selectedRow.hostel_name}
                  className="form-control"
                  readOnly
                />
              </div> */}
            </div>
            {showRejectReason && (
              <div className="mb-3">
                <label className="form-label">
                  {t("Reason for Rejection")}
                </label>
                <input
                  type="textbox"
                  name="rejectreason"
                  value={rejectReason}
                  className={`form-control ${
                    rejectReasonError ? "border-danger" : ""
                  }`}
                  onChange={(e) => setRejectReason(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.target.value.length >= 5) {
                      setRejectReasonError(false);
                    }
                  }}
                  required
                />
                {rejectReasonError && (
                  <small className="text-danger">
                    {t("Reason for Rejection is required")}.
                  </small>
                )}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={() => handleRejectWithReason(selectedRow)}
              >
                {t("Reject")}
              </Button>
              <button
                variant="contained"
                color="primary"
                style={{ position: "absolute",
                top: 10,
                right: 10,
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer",}}
                onClick={handleCloseModal}
              >
                <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                    </svg>
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Requirements;
